import React, { useState, useRef, useEffect } from 'react';
import { useIntersection } from '../../../hooks/useIntersection';

import {
  Nav,
  NavLink,
  NavItem,
  Badge,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownItem
} from 'reactstrap';
import { Link } from 'react-router-dom';

import { MoreHorizontal } from 'react-feather';
const ResponsiveNav = ({ responsiveItems, Tab, onToogle }) => {
  const parentDivRef = useRef();


  // useEffect(() => {
  //   const handleResize = () => {
  //     const parentDiv = parentDivRef.current;
  //     if (!parentDiv) return;

  //     const flexContainer = parentDiv.children[0];
  //     const flexItems = flexContainer?.children;
  //     let hItems = [];
  //     for (let flexItem of flexItems) {
  //       // console.log(flexItem.offsetTop)
  //       if (flexItem.offsetTop !== 14) {
  //         hItems.push({
  //           name: flexItem.getAttribute('attrName'),
  //           num: flexItem.getAttribute('attrNum')
  //         });
  //       }
  //     }
  //     setHiddenItems(hItems);
  //   };

  //   handleResize(); // Initial check
  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [isVisible]);

  return (
    <div
      // style={{
      //   position: 'relative',
      //   paddingRight: '10px'
      // }}
      ref={(el) => {
        parentDivRef.current = el;
      }}
      className='w-100 d-flex justify-content-center align-items-center justify-content-md-start'
    >
      <Nav
        tabs
        className="mb-0 py-1 "
        expand={true}
        style={{
          marginRight: '0 !important',
          flexWrap: 'wrap',
          overflow: 'hidden',
          maxHeight: '58px',
          textAlign: 'center',
        }}
      >
        {responsiveItems.map((item, index) => (
          <NavItem attrNum={item.num} attrName={item.str} key={index}>
            <NavLink
              active={Tab === item.tabId}
              onClick={() => {
                onToogle(item.tabId);
              }}
              className='px-1'
            >
              <span className="fw-bold align-middle">
                {item.str} <Badge color="light-secondary">{item.num}</Badge>
              </span>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      {/* 
      <UncontrolledDropdown
        setActiveFromChild
        direction="start"
        style={{ marginTop: "2px" }}
      >
        <DropdownToggle className="nav-link" tag="span" style={{ color: 'black' }}>
          <MoreHorizontal size={24} className="me-0 ms-auto cursor-pointer" />
        </DropdownToggle>
        <DropdownMenu>
          {hiddenItems.map((hItem, index) => {
            return (
              <DropdownItem key={index}>
                <NavItem>
                  <NavLink onClick={() => hiddenItemClick(hItem.name)}>
                    <span className="fw-bold">{hItem.name}</span>
                  </NavLink>
                </NavItem>
              </DropdownItem>
            );
          })}
        </DropdownMenu>
      </UncontrolledDropdown> */}
    </div>
  );
};

export default ResponsiveNav;
